import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import LoginHeader from './components/LoginHeader';
import LoginForm from './components/LoginForm';
import TrustSignals from './components/TrustSignals';
import FeatureHighlights from './components/FeatureHighlights';

const LoginPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user is already authenticated
    const isAuthenticated = localStorage.getItem('isAuthenticated');
    if (isAuthenticated === 'true') {
      navigate('/dashboard');
    }
  }, [navigate]);

  return (
    <>
      <Helmet>
        <title>Sign In - AccounTech AI | Intelligent Accounting Platform</title>
        <meta name="description" content="Sign in to AccounTech AI - Your comprehensive AI-powered accounting platform for complete financial management and business operations." />
        <meta name="keywords" content="accounting software, login, financial management, AI accounting, business accounting" />
      </Helmet>
      <div className="min-h-screen bg-background">
        {/* Main Login Section */}
        <div className="container mx-auto px-4 py-8">
          <div className="max-w-6xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
              {/* Left Column - Login Form */}
              <div className="order-2 lg:order-1">
                <div className="sticky top-8">
                  <LoginHeader />
                  <div className="bg-card border border-border rounded-xl shadow-professional p-8">
                    <LoginForm />
                  </div>
                </div>
              </div>

              {/* Right Column - Feature Highlights */}
              <div className="order-1 lg:order-2">
                <FeatureHighlights />
              </div>
            </div>
          </div>
        </div>

        {/* Trust Signals Section */}
        <div className="border-t border-border bg-muted/30">
          <div className="container mx-auto px-4 py-12">
            <TrustSignals />
          </div>
        </div>

        {/* Footer */}
        <footer className="border-t border-border bg-card">
          <div className="container mx-auto px-4 py-8">
            <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
              <div className="text-sm text-muted-foreground">
                © {new Date()?.getFullYear()} AccounTech AI. All rights reserved.
              </div>
              <div className="flex items-center space-x-6 text-sm">
                <a href="#" className="text-muted-foreground hover:text-foreground transition-colors">
                  Privacy Policy
                </a>
                <a href="#" className="text-muted-foreground hover:text-foreground transition-colors">
                  Terms of Service
                </a>
                <a href="#" className="text-muted-foreground hover:text-foreground transition-colors">
                  Support
                </a>
                <a href="#" className="text-muted-foreground hover:text-foreground transition-colors">
                  Contact
                </a>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default LoginPage;